/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesTextSnippetsDtosCreateTextSnippetRequest,
  FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto,
  FacilityFlowCoreModulesTextSnippetsDtosUpdateTextSnippetRequest,
  GetApiV1TextSnippetsParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getTextSnippets = () => {
/**
 * @summary List text snippets with optional category/active filters.
 */
const getApiV1TextSnippets = (
    params?: GetApiV1TextSnippetsParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto[]>(
      {url: `/api/v1/text-snippets`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Create a new text snippet.
 */
const postApiV1TextSnippets = (
    facilityFlowCoreModulesTextSnippetsDtosCreateTextSnippetRequest: FacilityFlowCoreModulesTextSnippetsDtosCreateTextSnippetRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>(
      {url: `/api/v1/text-snippets`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTextSnippetsDtosCreateTextSnippetRequest
    },
      options);
    }
  /**
 * @summary Get text snippet by ID.
 */
const getApiV1TextSnippetsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>(
      {url: `/api/v1/text-snippets/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Update an existing text snippet.
 */
const putApiV1TextSnippetsId = (
    id: string,
    facilityFlowCoreModulesTextSnippetsDtosUpdateTextSnippetRequest: FacilityFlowCoreModulesTextSnippetsDtosUpdateTextSnippetRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>(
      {url: `/api/v1/text-snippets/${id}`, method: 'PUT',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesTextSnippetsDtosUpdateTextSnippetRequest
    },
      options);
    }
  /**
 * @summary Delete a text snippet.
 */
const deleteApiV1TextSnippetsId = (
    id: string,
 options?: SecondParameter<typeof customInstance<void>>,) => {
      return customInstance<void>(
      {url: `/api/v1/text-snippets/${id}`, method: 'DELETE'
    },
      options);
    }
  /**
 * @summary Mark a text snippet as the default for its category (auto-applied in new offers).
 */
const postApiV1TextSnippetsIdSetDefault = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>>,) => {
      return customInstance<FacilityFlowCoreModulesTextSnippetsDtosTextSnippetDto>(
      {url: `/api/v1/text-snippets/${id}/set-default`, method: 'POST'
    },
      options);
    }
  return {getApiV1TextSnippets,postApiV1TextSnippets,getApiV1TextSnippetsId,putApiV1TextSnippetsId,deleteApiV1TextSnippetsId,postApiV1TextSnippetsIdSetDefault}};
export type GetApiV1TextSnippetsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['getApiV1TextSnippets']>>>
export type PostApiV1TextSnippetsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['postApiV1TextSnippets']>>>
export type GetApiV1TextSnippetsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['getApiV1TextSnippetsId']>>>
export type PutApiV1TextSnippetsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['putApiV1TextSnippetsId']>>>
export type DeleteApiV1TextSnippetsIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['deleteApiV1TextSnippetsId']>>>
export type PostApiV1TextSnippetsIdSetDefaultResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getTextSnippets>['postApiV1TextSnippetsIdSetDefault']>>>
